import React from "react";
import { CTAButton, Reveal } from "@/lib/uiHelpers";

export default function FinalCTA() {
  return (
    <section className="section-pad" style={{ backgroundColor: "#F5A623" }}>
      <div className="container-max">
        <Reveal className="text-center max-w-3xl mx-auto">
          <h2 className="font-head font-extrabold text-3xl md:text-5xl leading-tight" style={{ color: "#1A2B4A" }}>
            Stop Paying HECO&apos;s Price.
            <span className="block">Start Keeping Your Money.</span>
          </h2>
          <p className="font-body mt-5 text-base md:text-lg" style={{ color: "#3a2f12" }}>
            Every month you wait is another full month of an oversized HECO bill. Your 10-minute
            call costs nothing, and we&apos;ll show you which financing path fits best.
          </p>

          <div className="mt-8">
            <CTAButton testId="final-cta" variant="navy" full className="sm:w-auto">
              &rarr; YES &mdash; Book My Free Discovery Call Now
            </CTAButton>
          </div>

          <p className="font-body text-sm mt-6" style={{ color: "#1A2B4A" }}>
            No pressure. No obligation. Just your numbers. &nbsp;|&nbsp; Maui crew &nbsp;|&nbsp; HECO-compliant &nbsp;|&nbsp; Licensed &amp; Insured
          </p>
          <p className="font-body text-sm italic mt-3" style={{ color: "#3a2f12" }}>
            HECO rates aren&apos;t going down. The sooner you go solar, the sooner your savings begin.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
